import React from 'react'
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import ISJS2025Banner from '../assests/img/ISJS2025.jpg';
import Banner01 from '../assests/img/01.jpg';
import Banner02 from '../assests/img/02.jpg';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';


function Isjs2025() {
return (
    <div >
    
<Header/>
{/* <Showlist/> */}
<div className='container'>
    <div className='top-banner'>
        <img src={ISJS2025Banner} alt=""/>
    </div>
</div>

<div className='container main-contant'>
<Tabs>
    <TabList>
      <Tab>About ISJS Premiere 2025</Tab>
      <Tab>Visitor Registration</Tab>
      <Tab>Floorplan</Tab>
      <Tab>Exhibitors</Tab>
      <Tab>Exclusive</Tab>
    </TabList>

    <TabPanel>
    <h1>Silver Show in Jaipur | 2025</h1>
    <br/>
    <br/>

    <div className="d-table mx-auto mb-5 showDate">
                    <div className="row gx-lg-5 justify-content-center">
                        <div className="col-auto text-center">
                            <strong>
                                <h2>8-9-10 November 2025</h2>
                                <h3>10 am to 7 pm</h3>
                            </strong>
                                <span>JECC, Sitapura - Jaipur</span>
                        </div>                      
                    </div>
                </div>

                <p>
                The 40th edition of IIJS Premiere 2024 is all set to uncover the latest trends, letting you connect with industry leaders, and explore the grandeur of world's 2nd largest gem and jewellery B2B show. Be part of this iconic event and witness innovation and excellence in the gem and jewellery industry!
                </p>

                <div className='text-center'>
                <img className='text-center' src={Banner01} />
                </div>
                <br/>
                <br/>
                <br/>
                <div className='text-center'>
                <img className='text-center' src={Banner02} />
                </div>
                
      
    </TabPanel>
    <TabPanel>
      <h2>Any content 2</h2>
    </TabPanel>
    <TabPanel>
      <h2>Any content 2</h2>
    </TabPanel>
    <TabPanel>
      <h2>Any content 2</h2>
    </TabPanel>
    <TabPanel>
      <h2>Any content 2</h2>
    </TabPanel>
  </Tabs>


</div>



<br/>
<br/>
<br/>
<br/>
<br/>
<br/>
<br/>
<Footer/>
 </div>
)

}

export default Isjs2025;
